import { text_tertiary_dimmed } from "@/style/colors";
import { device } from "@/style/constants";
import { pxToRem } from "@/style/utils";
import styled from "styled-components";

export const ProductModalContainer = styled.div`
  /* how do their children behave */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* how is it shaped */
  height: calc(100% - 80px);
  /* where is it displayed */
  position: relative;
  top: 80px;
  /* how does it look */
  background: ${({ theme }) => theme.colors["gray.16"]};

  .close {
    position: absolute;
    background-color: ${({ theme }) => theme.colors["gray.99-alpha.40"]};
    width: ${pxToRem(32)};
    height: ${pxToRem(32)};
    top: 0;
    right: 0;
    margin: ${pxToRem(16)};
    z-index: 10;

    .label {
      transform: rotate(45deg);
      font-size: ${pxToRem(16)};
    }
  }

  @media ${device.laptop} {
    background-color: unset;
    top: 0;
    position: unset;
    height: 100%;
  }
`;
export const ProductNudge = styled.div`
  /* where is it displayed */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  /* how is it shaped */
  height: ${pxToRem(28)};
  padding: ${pxToRem(8)} ${pxToRem(6)};
  margin: ${pxToRem(16)};
  border-radius: ${pxToRem(32)};
  /* how do their children behave */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* how does it look */
  color: ${({ theme }) => theme.colors["gray.04"]};
  background-color: ${({ theme }) => theme.colors["gray.99-alpha.80"]};
  font-size: ${pxToRem(12)};
  font-weight: bold;
`;

export const ImageContainer = styled.div`
  /* how do their children behave */
  overflow: hidden;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  /* how is it shaped */
  flex: 0 1 auto;
  width: 100%;
  padding: 1rem;

  .background-image,
  .background-gradient {
    position: absolute;
    height: fill-available;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  .background-gradient {
    width: 100%;
    z-index: 1;
    background:
      linear-gradient(0deg, rgba(63, 61, 60, 0.4), rgba(63, 61, 60, 0.4)),
      linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
  }

  .product-asset {
    z-index: 1;
    width: 100%;
    height: 100%;
    margin: 2rem;
  }

  @media ${device.laptop} {
    height: ${pxToRem(336)};
  }
`;

export const ProductImage = styled.div<{ image: string }>`
  background: url(${({ image }) => image}) no-repeat center center;
  z-index: 2;
  width: 100%;
  height: 100%;
`;

export const BodyContainer = styled.div`
  margin: ${pxToRem(24)} 0 0;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: space-between;
`;

export const ProductDetails = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 1.5rem;

  color: ${({ theme }) => theme.colors["gray.99"]};

  @media ${device.laptop} {
    color: unset;
  }
`;

export const ItemType = styled.div`
  color: ${({ theme }) => theme.colors[`${theme.themeName}.primary.base`]};
  font-weight: bold;
  text-transform: uppercase;
`;

export const ItemName = styled.div`
  font-size: ${pxToRem(25)};
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${pxToRem(8)};
`;

export const ProductCost = styled.div`
  font-size: ${pxToRem(31)};
`;

export const ProductLabel = styled.p`
  color: ${text_tertiary_dimmed};
  font-size: ${pxToRem(13)};
`;

export const Actions = styled.div`
  /* how does it look */
  background: ${({ theme }) => theme.colors["gray.04"]};
  padding: ${pxToRem(24)} ${pxToRem(48)} ${pxToRem(16)};
  font-size: ${pxToRem(18)};
  /* how do their children behave */
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: ${pxToRem(12)};
  /* how is it shaped */
  min-height: ${pxToRem(200)};

  &.actions--small {
    /* how is it shaped */
    min-height: ${pxToRem(143)};
  }

  @media ${device.laptop} {
    font-size: ${pxToRem(12)};
    background-color: ${({ theme }) => theme.colors["gray-096"]};
  }
  button {
    text-transform: uppercase;
    height: ${pxToRem(57)};
  }

  button.buy-bundle {
    background: ${({ theme }) => theme.colors["gray-096"]};
    color: ${({ theme }) => theme.colors["gray.04"]};
    @media ${device.laptop} {
      background: ${({ theme }) => theme.colors["gray.04"]};
      color: ${({ theme }) => theme.colors["gray-096"]};
    }
  }

  button.buy-item {
    color: ${({ theme }) => theme.colors["gray.04"]};
    &--disabled {
      color: ${({ theme }) => theme.colors["gray.45"]};
      background: ${({ theme }) => theme.colors["gray.50-alpha.10"]};
      border: none;
    }

    @media ${device.laptop} {
      &--disabled {
        color: ${({ theme }) => theme.colors["gray.04-alpha.30"]};
      }
    }
  }

  button.see-bundle {
    color: ${({ theme }) => theme.colors["gray.78"]};
    background: ${({ theme }) => theme.colors["gray.04"]};

    @media ${device.laptop} {
      color: ${({ theme }) => theme.colors["gray.16"]};
      background: ${({ theme }) => theme.colors["gray.04-alpha.30"]};
    }
  }
`;

export const BuyActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: ${pxToRem(16)};

  button {
    width: ${pxToRem(264)};
  }
  @media ${device.mobileXL} {
    flex-direction: row;
  }
`;

export const ButtonContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${pxToRem(14)};
`;

export const ButtonPriceWrapper = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
  font-size: ${pxToRem(20)};
  align-items: center;
`;
